import React, { useEffect, useState } from "react";

const PageHeader = (props) => {
  useEffect(() => {
    let currentUrl = window.location.href.split("/");
  }, []);
  return (
    <>
      {/* page header starts here */}
      <section className="pageheader">
        <div className="container">
          <div className="for-pageheader-back">
            <div className="row">
              <div className="col-lg-12">
                <div className="content-wrapper">
                  <h2 className="primary-color">{props.pagename}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* page header ends here */}
    </>
  );
};

export default PageHeader;